import React from "react";

const MacroDividerBlock = {
  label: "Divider",
  llmDescription: `A horizontal rule divider for separating sections in email content.
- No configurable properties
- Renders as an <hr> element
- Use between major sections of the email for visual separation`,
  fields: {},
  defaultProps: {},
  render: () => {
    return <hr />;
  },
};

export default MacroDividerBlock;
